import React, {Component} from "react";
import payment from "../../images/payment.png"

class FooterLanding extends Component {

    render() {
        return (
            <div>
                <footer className="footer">
                    <div className="container">
                        <div className="row">
                            <div className="mt-4 col-lg-3"><h4>TUTORFEST</h4>
                                <div className="text-muted mt-4">
                                    <ul className="list-unstyled footer-list">
                                        <li><a className="text-white" href="/">Home</a></li>
                                        <li><a className="text-white" target="_blank" href="/hom">Web</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mt-4 col-lg-3"><h4>Information</h4>
                                <div className="text-muted mt-4">
                                    <ul className="list-unstyled footer-list">
                                        <li><a className="text-white" href="/privacy-and-policy"
                                               target="_blank">Terms &amp; Condition</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mt-4 col-lg-3"/>
                            <div className="mt-4 col-lg-3"><h4>About us</h4>
                                <div className="text-muted mt-4"><p>Lorem ipsum
                                    dolor sit amet, consectetur
                                    adipiscing
                                    elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="footer-alt">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 d-flex flex-row justify-content-between">
                                <div className="pull-none">
                                    <p className="copy-rights text-muted">2022 - 2023 © Tutorfest Website</p>
                                </div>
                                <div className="pull-none">
                                    <img src={payment} alt="payment" height="36"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FooterLanding
